import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { AuthService } from '../../core/services/auth/auth.service';

@Directive({
  selector: '[hasPermission]'
})
export class HasPermissionDirective implements OnInit, OnChanges {
  @Input() hasPermission: string | string[] = '';
  @Input() requireAll: boolean = false;

  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.updateView();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['hasPermission'] || changes['requireAll']) {
      this.updateView();
    }
  }

  private updateView() {
    const hasAccess = this.checkPermission();

    if (hasAccess && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasAccess && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  private checkPermission(): boolean {
    if (!this.hasPermission) {
      return false;
    }

    if (Array.isArray(this.hasPermission)) {
      if (this.hasPermission.length === 0) {
        return false;
      }
      return this.requireAll
        ? this.authService.hasAllPermissions(this.hasPermission)
        : this.authService.hasAnyPermission(this.hasPermission);
    } else {
      return this.authService.hasPermission(this.hasPermission);
    }
  }
}
